<script>
	import { Runtime } from '@observablehq/runtime'
	import { FragInspector } from './observablehq/FragInspector'
	import { onMount, onDestroy, getContext } from 'svelte'
	import { writable } from 'svelte/store'
	import { uuid } from './uuid'
	import { createEventDispatcher } from 'svelte';
	import {removeReadyStoreKey, updateReadyStore} from "./print-util/readyStore";

	const dispatch = createEventDispatcher();

	export let cells;
	export let notebook;
	export let redefineWidth = false;
	export let overrides = new Map();
	export let extraClass = undefined;
	export let hide = [];
	export let cellValues = null;

	export let runtime = undefined;
	// This is a way, even though an anti-pattern, to
	// change properties of the runtime:
	// **********************************************
	// function augmentRuntime(runtime) {
	// 	let oldComputeNow = runtime._computeNow;
	// 	runtime.__proto__._computeNow = function() {
	// 		const wereDirty = new Set(this._dirty);
	// 		oldComputeNow.bind(this).call();
	// 		console.log(`computeNow: `, wereDirty);
	// 	};
	// 	console.log('augment')
	// }

	$: notebookClass = extraClass ? `frag-notebook ${extraClass}` : 'frag-notebook';

	let hidden = {}
	hide.map(cellName => hidden[cellName] = true);

	let container;
	let cellRefs = {};

	let width

	let handleResize = redefineWidth ? () => {
		if (container) {
			width = container.getBoundingClientRect().width
		}
	} : () => {};

	export let notebookModule = undefined;

	const instanceId = `Notebook:${uuid()}`;

	const readyStore = getContext('readyStore') || writable(new Map());

	$: if (redefineWidth && notebookModule && width) {
		try {
			notebookModule.redefine('width', width)
		} catch (e) {
			console.warn(e);
		}
	}

	let notebookResult = writable(null);

	const cellReadyState = new writable(new Map())

	$: if (notebook) {
		if (runtime) {
			runtime.dispose();
			/*@__PURE__*/
			runtime = new Runtime();
		}

		notebookResult.set(null);

		Promise.resolve(notebook)
				.then(nb => {
					notebookResult.set(nb)
				});
	}



	onMount(async () => {
		handleResize()
		/*@__PURE__*/
		runtime = new Runtime();
		// augmentRuntime(runtime);
	});

	$: if (cells || $notebookResult) {
		cellReadyState.update(st => {
			return new Map(cells.map(c => [c, 'pending']));
		});
	}

	let done = false
	let lastNotebookResult = null

	$: if (!done || $notebookResult !== lastNotebookResult) {
		lastNotebookResult = $notebookResult
		notebookModule = runtime && $notebookResult ? runtime.module($notebookResult, name => {
			done = true;
			if (!cellValues) {
				cellValues = {};
			}
			if (name in cellRefs) {
				return new FragInspector(cellRefs[name], (state, fulfilledName, fulfilledValue) => {
					cellReadyState.update(st => {
						const newState = new Map(st)
						newState.set(name, state)
						if (
							state === 'fulfilled' &&
							fulfilledName && fulfilledValue &&
							cellValues[fulfilledName] !== fulfilledValue
						) {
							// either with bind:
							cellValues[fulfilledName] = fulfilledValue;
							// or with event:
							dispatch(`change:${fulfilledName}`, fulfilledValue);
						}

						return newState;
					});
				})
			}
		}) : undefined;
	}

	$: if ($cellReadyState) {
		const allResolved = ![...$cellReadyState.values()].some(s => s === 'pending');

		if (instanceId) {
			updateReadyStore(readyStore, instanceId, allResolved);
		}
	}

	$: if (notebookModule && overrides) overrides.forEach((v, k) => notebookModule.redefine(k, v));

	onDestroy(() => {
		if (runtime) {
			runtime.dispose();
		}

		removeReadyStoreKey(readyStore, instanceId);
	})
</script>

<style>
	@media print {
		:global(.observablehq) {
			break-inside: avoid;
			page-break-inside: avoid;
		}

		.frag-notebook {
			break-before: avoid;
			page-break-before: avoid;
		}
	}

	.frag-notebook {
		position: relative;
	}

	/*.frag-notebook :global(.observablehq--running):after {
		display: block;
		content: 'loading';
		position: absolute;
		top: 0;
		color: white;
		height: 100%;
		min-height: 100px;
		width: 100%;
		line-height: 100%;
		text-align: center;
		background: rgba(64, 64, 64, 0.7);
	}*/
	.hidden {
		display: none;
	}
</style>

<svelte:window on:resize={handleResize}/>

{#await notebook}
	<p>loading...</p>
{:then value}
	<div bind:this={container} class="{notebookClass}" data-uuid={instanceId}>
		{#each cells as cell, index}
			{#if hidden[cell] }
				<div class="hidden" bind:this={cellRefs[cell]} data-cell={cell}></div>
			{:else}
				<div bind:this={cellRefs[cell]} data-cell={cell}></div>
			{/if}
		{/each}
	</div>
	<!-- <div>
		VALUES: {JSON.stringify(cellValues)}
	</div> -->
{:catch error}
	<p>something went wrong: {error.message}</p>
{/await}
